<template>
  <ModalTemplate
    transitionName="fade"
    :isModalOpen="showModal.isLicense"
    errorTitle="OSS Notice"
    :isLicenceMeteIcon="true"
  >
    <template v-slot:contentDescription>
      This application Copyright ⓒ 2024 CONTEC All rights Reserved.<br />
      This application use Open Source Software (OSS).<br />You can find the source code of these open source
      projects, along with applicable license information, below.<br />We are deeply grateful to these developers and
      their work and contributions.<br />
      Any questions about our use of licensed work can be sent to <span class="text_accent">
        info@contec.kr
      </span>
    </template>
    <template v-slot:contact>
      <div class="contact">
        <p>
          <span>
            GeoTools
          </span>
        </p>
        <p>
          ∙ <a href="https://github.com/geotools/geotools" target="_blank">
            https://github.com/geotools/geotools
          </a>
        </p>
        <p>
          ∙ LGPL-2.1 license
        </p>
      </div>
    </template>
  </ModalTemplate>
</template>

<script setup lang="ts">
import ModalTemplate from '@/components/common/modal/ModalTemplate.vue';
import useCommonStore from '@/store/storeCommon';

const { showModal } = useCommonStore();
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.contact {
  margin: 7.7px auto 8.4px;
  font-size: 12px;
  text-align: left;

  p {
    font-family: "Pretendard Light 300", sans-serif;

    span {
      font-family: "Pretendard SemiBold 600", sans-serif;
      color: $color-debra;
    }
  }
}

.text_accent {
  padding: 0 2px;
  color: black;
  background-color: $color-mete;
}

a:link, a:visited {
  color: $color-mete;
  text-decoration: underline;
}
</style>